/* ez-delivery.js — Ban-53 (EZ), simpler in Ban-54: estimated delivery worked out in the browser from the rules in
   Shopify admin (Content › Metaobjects: ez_delivery_route, ez_product_line, ez_occasion, ez_extra_days, ez_cutoff), which
   snippets/ez-delivery-data.liquid writes into the page as numbers only (#ezDeliveryData).

   Why in the browser: Shopify keeps product pages in its cache, so a date worked out in Liquid could still say
   "yesterday" after midnight; the rules never go stale, today's date is always the visitor's own.

   What it fills (the same dates everywhere):
     - "Estimated delivery: Oct 23 - 27" next to the price (.new-shipping .date-time-new)
     - the 3 steps under Add to cart and in the Estimated delivery popup (#ezTrustTpl and its copies)
     - the theme's delivery box (.timeline-current / .timeline-ship / .timeline-delivered)
     - "Arrives …" in the Shipping & Returns tab
   plus, for an occasion the owner switched on, one line of his own words ("Order by Dec 12 to get it before
   Christmas" / "May arrive after Christmas").

   How a date is made (calendar days, as measured on 4,025 tracked parcels in Oct 2026):
     today + making days + shipping days (+ the largest ez_extra_days that applies), shown as a range.
   Product line (Ban-54: no priority box) = the line with the LONGEST keyword found in the chosen variant (Teeinblue's
   "Available Product" and the variant title), else in the product type / tags, else the line "default" if there is
   one, else "every other product" (Asia, the route's making days). Checked on all 40,351 variants: same lines as the
   Ban-53 priorities, and 8 lines give every variant the same ship-from as the 16 lines of Ban-53.
   Ban-55: "(Print in USA)" in the chosen base's name → US customers get it from the US, whatever the line says.
   Ban-60: EZ Product base = the owner's settings for one Teeinblue base (by its id), above everything else: where each
   market gets it from, making days, extra shipping days. Keywords typed together ("A · B") are split.
   Ban-59: fixed rule of where each market may be shipped from (US: Asia/US · CA: Asia/US/CA · UK, EU: Asia/UK/EU ·
   AU: Asia/AU · ROW: Asia); "Print(ed)/Made in US/USA/CA/UK/EU/AU" in the base's name → that market from there.
   Ban-58: a base added by hand in Teeinblue has no printer id → the printer is found by its name / keywords in the
   base's label ("3D Acrylic Ball - Falconprint"); "Made in US" counts as "Print in USA".
   Ban-57: the printer of the chosen variant is read from Teeinblue's campaign data (fulfillment id) and looked up in
   ez_supplier (one entry per printer): new bases need nothing. Order per market: line box (not Asia) → "Print in USA"
   base (US) → printer → Asia. Making days: line → printer → route.
   Ban-56: each product line says where each market gets it from (US/CA/UK/EU/AU/ROW from; empty = Asia); the
   owner's routes (any origin Asia / US / UK / EU / AU → market) give the days. A missing route = Asia days + an error.
   Ship from = Asia, or US when the line says "US customers get it from: US" and the customer is in the US.

   Preview without waiting for a date: add ?ez_today=2026-12-05 (and ?ez_country=AU) to a product page;
   ?ez_delivery_check=1 opens the owner's check (Vietnamese): what is missing or wrong in the Metaobjects, then a
   table of every product line × region. It also works before any route exists (the page still shows the old dates). */
(function () {
  "use strict";
  var el = document.getElementById("ezDeliveryData");
  if (!el) return;
  var D;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }
  if (!D) return;
  D.routes = D.routes || []; D.lines = D.lines || []; D.occasions = D.occasions || []; D.extras = D.extras || []; D.cutoffs = D.cutoffs || []; D.suppliers = D.suppliers || []; D.bases = D.bases || [];
  /* Ban-60: several keywords typed in one box ("TEE · T SHIRT · HOODIE") are split on · , ; | */
  var SPLIT_FIXED = [];
  function splitKw(list, owner) {
    var out = [];
    (list || []).forEach(function (k) {
      var parts = String(k || "").split(/\s*[·•,;|]\s*/).filter(function (x) { return x.trim(); });
      if (parts.length > 1) SPLIT_FIXED.push([owner, k]);
      out.push.apply(out, parts);
    });
    return out;
  }
  D.lines.forEach(function (l) { l.keywords = splitKw(l.keywords, l.name || l.id); });
  /* Ban-148 (anh 24/10 00:03, tạm thời mùa Christmas): một ô Keywords dạng "US=8-10", "CA=10-15", "UK=…", "EU=…",
     "AU=…", "ROW=…" (hoặc "US=9") = số ngày khách nhận hàng cố định cho dòng này ở nước đó, không quan tâm gửi từ đâu
     (nhà in, base, tuyến). Các ô này không dùng để khớp sản phẩm. Muốn bỏ: xóa ô đó, dòng lại tính như trước. */
  var FIXED_RE = /^(US|CA|UK|GB|EU|AU|ROW)\s*=\s*(\d{1,3})(?:\s*(?:-|–|—|to)\s*(\d{1,3}))?$/i;
  D.lines.forEach(function (l) {
    l.fixed = {};
    l.keywords = (l.keywords || []).filter(function (k) {
      var m = FIXED_RE.exec(String(k || "").trim());
      if (!m) return true;
      var r = m[1].toUpperCase(), a = +m[2], b = m[3] != null ? +m[3] : a;
      if (r === "GB") r = "UK";
      l.fixed[r] = a <= b ? [a, b] : [b, a];
      return false;
    });
  });
  D.suppliers.forEach(function (x) { x.keywords = splitKw(x.keywords, x.name || x.id); });
  var LIVE = D.routes.length > 0;   /* no route yet → the old dates stay, only the owner's check runs */

  var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var EU = "AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE NO CH IS LI".split(" ");
  var REGIONS = ["US", "CA", "AU", "UK", "EU", "ROW"];
  var qs = new URLSearchParams(location.search);

  /* ---------- dates: plain calendar days, kept in UTC so a clock change never shifts a day ---------- */
  function ymd(s) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || ""); return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null; }
  function todayUTC() {
    var t = ymd(qs.get("ez_today"));
    if (t !== null) return t;
    var n = new Date();
    return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
  }
  var DAY = 864e5;
  function add(t, n) { return t + n * DAY; }
  function md(t) { var d = new Date(t); return MON[d.getUTCMonth()] + " " + d.getUTCDate(); }
  function sameMonth(a, b) { var x = new Date(a), y = new Date(b); return x.getUTCMonth() === y.getUTCMonth() && x.getUTCFullYear() === y.getUTCFullYear(); }
  /* "Oct 23 - 27" / "Oct 30 - Nov 4" (the line next to the price and the theme's box) */
  function rangeA(a, b) { return a === b ? md(a) : sameMonth(a, b) ? md(a) + " - " + new Date(b).getUTCDate() : md(a) + " - " + md(b); }
  /* "Oct 23–27" / "Oct 30 – Nov 4" (the 3 steps) */
  function rangeB(a, b) { return a === b ? md(a) : sameMonth(a, b) ? md(a) + "–" + new Date(b).getUTCDate() : md(a) + " – " + md(b); }

  /* ---------- who, where, what ---------- */
  function regionOf(c) {
    c = (c || "").toUpperCase();
    if (c === "US" || c === "CA" || c === "AU") return c;
    if (c === "GB" || c === "UK") return "UK";
    if (EU.indexOf(c) >= 0) return "EU";
    return "ROW";
  }
  function country() {
    return (qs.get("ez_country") || (window.Shopify && window.Shopify.country) || D.country || "US").toUpperCase();
  }
  /* the address bar first: Teeinblue changes ?variant= at once when a style/size is picked, while the form's
     hidden id is only filled in at Add to cart (checked on TEST 5, Christmas Farm: POSTER → CANVAS) */
  function variantId() {
    var v = new URLSearchParams(location.search).get("variant");
    if (v && D.product.variants && D.product.variants[v]) return v;
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return String((inp && inp.value) || D.product.variant || "");
  }
  function norm(s) { return " " + String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, " ").trim() + " "; }
  function hits(hay, kw) { var k = norm(kw); return k.length > 2 && hay.indexOf(k) >= 0; }
  var LINES = D.lines;
  var OTHER = { id: "", name: "Mọi sản phẩm khác", keywords: [], us_from: "Asia", make: [null, null] };
  function isDefault(l) { return /^default$|^mac-dinh$/i.test(l.id || "") || /^(default|mặc định)$/i.test(String(l.name || "").trim()); }
  /* the longest keyword wins ("PRINT IN USA" before "CAP"); equal length → the line entered first */
  function longest(text) {
    var best = null, bl = 0, i, j, l, n;
    for (i = 0; i < LINES.length; i++) { l = LINES[i]; for (j = 0; j < (l.keywords || []).length; j++) if (hits(text, l.keywords[j])) { n = norm(l.keywords[j]).length; if (n > bl) { bl = n; best = l; } } }
    return best;
  }
  /* Ban-55: a product base named "… (Print in USA)" / "Printed in USA" is printed in the US for US customers
     (Printbelle's US bases; customers elsewhere still get it from Asia). The words are taken out before the line is
     looked up, so "Poster(Print in USA)" stays on the Poster line (its cutoffs) and simply ships from the US. */
  /* Ban-59: "Print / Printed / Made in US·USA·CA·UK·EU·AU" in the base's name → customers OF THAT MARKET get it from
     there (a Printbelle "Print in USA" base is for US customers only); other markets follow the printer / Asia. */
  var USA_RE = / (?:PRINT(?:ED)?|MADE) IN (?:THE )?(USA|US|UNITED STATES|CANADA|CA|UK|UNITED KINGDOM|GB|EU|EUROPE|AU|AUSTRALIA) /;
  var SUFFIX_TO = { USA: "US", US: "US", "UNITED STATES": "US", CANADA: "CA", CA: "CA", UK: "UK", "UNITED KINGDOM": "UK", GB: "UK", EU: "EU", EUROPE: "EU", AU: "AU", AUSTRALIA: "AU" };
  function usaBase(t) { return USA_RE.test(t); }
  /* strips every suffix out of t, returns { text, local: { US: "US", UK: "UK", … } } */
  function suffixes(t) {
    var local = {}, m;
    while ((m = USA_RE.exec(t))) { var o = SUFFIX_TO[m[1]]; local[o] = o; t = t.slice(0, m.index) + " " + t.slice(m.index + m[0].length - 1); }
    return { text: t, local: local };
  }
  /* Ban-57: TEE[shopify variant id] = { f: Teeinblue fulfillment id (the printer), title, label } of the base that
     variant uses, read from the campaign data Teeinblue loads on the page (loadTee below). */
  var TEE = null, TEE_STATE = "chưa đọc";
  /* by Teeinblue's printer id; Ban-58: a base added by hand has none → the printer whose name or keywords are written
     in the base's label / title / internal tags ("3D Acrylic Ball - Falconprint"), longest match wins */
  function supplierOf(base) {
    if (!base) return null;
    var i, j;
    if (base.f != null && String(base.f) !== "") {
      for (i = 0; i < D.suppliers.length; i++) if (D.suppliers[i].tib != null && String(D.suppliers[i].tib) === String(base.f)) return D.suppliers[i];
      return null;
    }
    var t = norm(base.label + " " + base.title + " " + base.tags), best = null, bl = 0, w, n;
    for (i = 0; i < D.suppliers.length; i++) {
      w = [D.suppliers[i].name].concat(D.suppliers[i].keywords || []);
      for (j = 0; j < w.length; j++) if (w[j] && hits(t, w[j])) { n = norm(w[j]).length; if (n > bl) { bl = n; best = D.suppliers[i]; } }
    }
    return best;
  }
  function lineFor(vid) {
    var base = TEE && TEE[String(vid)] || null;
    var sf = suffixes(norm(((D.product.variants || {})[vid] || "") + (base ? " | " + base.title + " | " + base.label : ""))), vt = sf.text;
    var usa = Object.keys(sf.local).length ? sf.local : null;
    var l = longest(vt) || longest(norm(D.product.type + " " + (D.product.tags || []).join(" "))), i;
    if (!l) { for (i = 0; i < LINES.length; i++) if (isDefault(LINES[i])) { l = LINES[i]; break; } }
    if (!l) l = OTHER;
    var c = {}; for (var k in l) c[k] = l[k];
    c.usaBase = usa; c.base = base; c.supplier = supplierOf(base); c.pbase = baseCfg(base);
    return c;
  }
  /* Ban-56: the owner says, per product line, where each market gets it from ("US from", "CA from", "UK from",
     "EU from", "AU from", "ROW from"; empty = Asia). The days of that origin → market come from his routes. */
  var ORIGINS = ["Asia", "US", "CA", "UK", "EU", "AU"];
  var ORIGIN_VN = { Asia: "Châu Á", US: "Mỹ", CA: "Canada", UK: "Anh", EU: "EU", AU: "Úc" };
  /* Ban-59 (owner's rule): where each market may be shipped from — anything else is ignored (→ next choice / Asia) */
  var ALLOWED = { US: ["Asia", "US"], CA: ["Asia", "US", "CA"], UK: ["Asia", "UK", "EU"], EU: ["Asia", "EU", "UK"], AU: ["Asia", "AU"], ROW: ["Asia"] };
  function allowed(region, o) { return (ALLOWED[region] || ["Asia"]).indexOf(o) >= 0; }
  function canon(o) { for (var i = 0; i < ORIGINS.length; i++) if (same(ORIGINS[i], o)) return ORIGINS[i]; return null; }
  /* Ban-57, in this order: the product line (only when the owner filled the box with something other than Asia —
     his exception, e.g. Canada from the US before Christmas) → a base named "Print in USA" (US customers) → the
     printer (EZ Supplier) → Asia. */
  /* the campaign data Teeinblue itself fetched on this page (same address → served from the browser cache, nothing
     extra downloaded); only if it never shows up do we ask for it once ourselves. Any failure → no printer known,
     everything works as before (product lines / "Print in USA" / Asia). */
  function teeUrl() {
    if (!D.product.id || !window.performance || !performance.getEntriesByType) return null;
    var re = new RegExp("api\\.teeinblue\\.com/api/merchant/campaigns/" + D.product.id + "\\.json"), e = performance.getEntriesByType("resource"), i;
    for (i = e.length - 1; i >= 0; i--) if (re.test(e[i].name)) return e[i].name;
    return null;
  }
  function isTee() { var c = window.teeinblueCampaign; return !!(c && (c.isTeeInBlueProduct || c.isPlatformProduct)); }
  var teeTries = 0, onTee = function () {};
  function loadTee() {
    if (TEE || TEE_STATE === "đang đọc" || !D.product.id) return;
    var url = teeUrl();
    if (!url) {
      if (++teeTries < 8) { setTimeout(loadTee, 500); return; }   /* give Teeinblue ~4 s to fetch it first */
      var shop = window.Shopify && window.Shopify.shop;
      if (!shop || !isTee()) { TEE_STATE = "không phải sản phẩm Teeinblue"; onTee(); return; }
      url = "https://api.teeinblue.com/api/merchant/campaigns/" + D.product.id + ".json?shop=" + encodeURIComponent(shop);
    }
    TEE_STATE = "đang đọc";
    fetch(url, { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }).then(function (j) {
      var cv = {}, map = {}, n = 0;
      (j.campaign_products || []).forEach(function (cp) {
        var p = cp.product || {};
        var tags = p.internal_tags == null ? "" : [].concat(p.internal_tags).join(" ");
        (cp.campaign_variants || []).forEach(function (v) { cv[String(v.variant_id)] = { id: p.id, f: p.fulfillment_id, title: p.title || "", label: p.label || "", tags: tags }; });
      });
      (j.instance_variants || []).forEach(function (iv) { var b = cv[String(iv.variant_id)]; if (b) { map[String(iv.platform_linked_id)] = b; n++; } });
      TEE = n ? map : null; TEE_STATE = n ? "đã đọc" : "dữ liệu Teeinblue không có biến thể";
      onTee();
    }).catch(function () { TEE_STATE = "không đọc được dữ liệu Teeinblue"; onTee(); });
  }
  /* Ban-60: the owner's own settings for one product base (EZ Product base, by Teeinblue base id) */
  function baseCfg(base) {
    if (!base || base.id == null) return null;
    for (var i = 0; i < D.bases.length; i++) if (D.bases[i].tid != null && String(D.bases[i].tid) === String(base.id)) return D.bases[i];
    return null;
  }
  function pick(v) { var o = canon(String(v || "").trim()); return o && o !== "Asia" ? o : null; }
  function fromOf(line, region) {
    var c = [line.pbase ? pick(line.pbase.from && line.pbase.from[region]) : null,
             pick(line.from && line.from[region]) || (region === "US" ? pick(line.us_from) : null),
             line.usaBase && line.usaBase[region] || null,
             line.supplier ? pick(line.supplier.from && line.supplier.from[region]) : null];
    for (var i = 0; i < c.length; i++) if (c[i] && allowed(region, c[i])) return c[i];
    return "Asia";
  }
  function originFor(line, region) { return fromOf(line, region); }
  /* exact origin → market; a missing local route falls back to Asia (and the owner's check says so) */
  function routeFor(origin, region) {
    var r = D.routes, i;
    for (i = 0; i < r.length; i++) if (same(r[i].from, origin) && same(r[i].region, region)) return r[i];
    for (i = 0; i < r.length; i++) if (same(r[i].from, "Asia") && same(r[i].region, region)) return r[i];
    for (i = 0; i < r.length; i++) if (same(r[i].from, "Asia") && same(r[i].region, "ROW")) return r[i];
    return r[0];
  }
  function same(a, b) { a = String(a || "").toUpperCase(); b = String(b || "").toUpperCase(); if (a === "GB") a = "UK"; if (b === "GB") b = "UK"; return a === b; }
  function inList(list, id) { return !list || !list.length || list.indexOf(id) >= 0; }
  function forRegion(o, region) { return !o.regions || !o.regions.length || o.regions.some(function (r) { return same(r, region); }); }

  /* ---------- the estimate ---------- */
  function estimate(line, region, today) {
    var origin = originFor(line, region), route = routeFor(origin, region);
    /* making days: the line's own → the printer's own → the route's */
    /* making days: the base's own → the line's → the printer's → the route's */
    var sm = (line.supplier && line.supplier.make) || [null, null], bm = (line.pbase && line.pbase.make) || [null, null];
    var make = [0, 1].map(function (i) { return bm[i] != null ? bm[i] : line.make && line.make[i] != null ? line.make[i] : sm[i] != null ? sm[i] : route.make[i]; });
    var sx = (line.pbase && line.pbase.ship_extra) || [null, null], shipAdd = [sx[0] || 0, sx[1] != null ? sx[1] : sx[0] || 0];
    var extra = 0, extraBy = null;
    D.extras.forEach(function (o) {
      if (!o.days) return;
      var f = ymd(o.from), t = ymd(o.to);
      if ((f !== null && today < f) || (t !== null && today > t) || (f === null && t === null)) return;
      if (!/^all$/i.test(o.origin || "All") && !same(o.origin, origin)) return;
      if (!inList(o.lines, line.id) || !forRegion(o, region)) return;
      if (o.days > extra) { extra = o.days; extraBy = o; }   /* two periods at once: the larger, never added up */
    });
    var s0 = add(today, (make[0] || 0) + extra), s1 = add(today, (make[1] || 0) + extra);
    var a0 = add(s0, (route.ship[0] || 0) + shipAdd[0]), a1 = add(s1, (route.ship[1] || 0) + shipAdd[1]);
    /* Ban-148: số ngày cố định của dòng ở nước này (+ ngày cộng thêm mùa cao điểm nếu có); ngày gửi đi giữ cách tính cũ
       nhưng luôn trước ngày nhận sớm nhất */
    var fx = line.fixed && line.fixed[region] || null;
    if (fx) {
      a0 = add(today, fx[0] + extra); a1 = add(today, fx[1] + extra);
      if (s1 >= a0) s1 = Math.max(today, add(a0, -1));
      if (s0 > s1) s0 = s1;
    }
    return { origin: origin, route: route, make: make, shipAdd: shipAdd, extra: extra, extraBy: extraBy, ship: [s0, s1], arrive: [a0, a1], today: today, fixed: fx };
  }
  /* the nearest switched-on occasion still ahead, its last order date for this line and region, and the words */
  function notice(line, region, est) {
    var today = est.today, best = null;
    (D.occasions || []).forEach(function (o) {
      var d = ymd(o.date);
      if (!o.notice || d === null || today > d || !forRegion(o, region)) return;
      var from = ymd(o.notice_from);
      if (from !== null && today < from) return;
      if (!best || d < ymd(best.date)) best = o;
    });
    if (!best) return null;
    var cut = null, cutAll = null;
    (D.cutoffs || []).forEach(function (c) {
      if (c.occasion !== best.id) return;
      if (c.origin && String(c.origin).trim() && !same(c.origin, est.origin)) return;   /* Ban-56: this list is for another ship-from */
      var v = c.dates && c.dates[region];
      if (!v) return;
      if (c.lines && c.lines.length) { if (c.lines.indexOf(line.id) >= 0) cut = ymd(v); }
      else cutAll = ymd(v);
    });
    if (cut === null) cut = cutAll;
    if (cut === null) cut = add(ymd(best.date), -(est.fixed ? est.fixed[1] + est.extra : (est.make[1] || 0) + (est.route.ship[1] || 0) + (est.shipAdd ? est.shipAdd[1] : 0) + est.extra));   // Ban-148   // not on the list: from the latest arrival
    var before = today <= cut;
    var words = before ? (best.text_before || "Order by {date} to get it before {occasion}") : (best.text_after || "May arrive after {occasion}");
    return { before: before, cutoff: cut, occasion: best, text: words.replace(/\{date\}/g, md(cut)).replace(/\{occasion\}/g, best.name || "") };
  }

  /* ---------- writing it into the page ---------- */
  function setText(node, txt) { if (node && node.textContent.trim() !== txt) node.textContent = txt; }
  function noteNode(host, n, cls) {
    var p = host.querySelector(":scope > .ezdl-note");
    if (!n) { if (p) p.remove(); return; }
    if (!p) { p = document.createElement("p"); host.appendChild(p); }
    p.className = "ezdl-note " + cls + (n.before ? " ezdl-note--before" : " ezdl-note--after");
    setText(p, n.text);
  }
  function fillSteps(root, est, n) {
    Array.prototype.forEach.call(root.querySelectorAll(".ezp-steps-wrap"), function (w) {
      setText(w.querySelector(".ezp-steps__title b"), rangeB(est.arrive[0], est.arrive[1]));
      var b = w.querySelectorAll(".ezp-steps > li > b");
      if (b[0]) setText(b[0], md(est.today));
      if (b[1]) setText(b[1], rangeB(est.ship[0], est.ship[1]));
      if (b[2]) setText(b[2], rangeB(est.arrive[0], est.arrive[1]));
      var t = w.querySelector(".ezp-steps__title");
      if (t) {
        var p = w.querySelector(":scope > .ezdl-note");
        if (!n) { if (p) p.remove(); }
        else {
          if (!p) { p = document.createElement("p"); t.insertAdjacentElement("afterend", p); }
          p.className = "ezdl-note ezdl-note--steps" + (n.before ? " ezdl-note--before" : " ezdl-note--after");
          setText(p, n.text);
        }
      }
    });
  }
  var last = "";
  function apply() {
    var region = regionOf(country()), today = todayUTC(), line = lineFor(variantId());
    var est = estimate(line, region, today), n = notice(line, region, est);
    var a = rangeA(est.arrive[0], est.arrive[1]);
    Array.prototype.forEach.call(document.querySelectorAll(".new-shipping .date-time-new"), function (x) { setText(x, a); });
    Array.prototype.forEach.call(document.querySelectorAll(".new-shipping .box-shipping-content"), function (x) { noteNode(x, n, "ezdl-note--line"); });
    Array.prototype.forEach.call(document.querySelectorAll(".timeline-date.timeline-current"), function (x) { setText(x, md(today)); });
    Array.prototype.forEach.call(document.querySelectorAll(".timeline-date.timeline-ship"), function (x) { setText(x, rangeA(est.ship[0], est.ship[1])); });
    Array.prototype.forEach.call(document.querySelectorAll(".timeline-date.timeline-delivered"), function (x) { setText(x, a); });
    Array.prototype.forEach.call(document.querySelectorAll(".ezd--tab .ezd-arrive strong"), function (x) { setText(x, "Arrives " + a); });
    var tpl = document.getElementById("ezTrustTpl");
    if (tpl && tpl.content) fillSteps(tpl.content, est, n);
    fillSteps(document, est, n);
    document.documentElement.setAttribute("data-ez-delivery", line.id || "none");
    window.ezDelivery = { line: line, region: region, estimate: est, notice: n };
    var key = line.id + "|" + region + "|" + a + "|" + (n ? n.text : "") + "|" + (line.base ? line.base.f : TEE_STATE);
    if (key !== last) { last = key; if (qs.get("ez_delivery_check")) check(); }
  }

  /* ---------- the owner's check (?ez_delivery_check=1), in Vietnamese: problems first, then the table ---------- */
  function num(x) { return x == null ? "?" : x; }
  function okRegion(r) { return REGIONS.some(function (x) { return same(x, r); }); }
  function problems(today) {
    var P = [];
    function add3(level, type, item, text) { P.push({ level: level, type: type, item: item, text: text }); }
    function nm(x, i) { return x.name || x.id || "mục " + (i + 1); }
    /* a field Shopify never returns for ANY entry = its key is probably not the one in HUONG-DAN */
    function keyCheck(type, list, label, key, get) {
      if (list.length && list.every(function (x) { var v = get(x); return v == null || (Array.isArray(v) && !v.length); })) {
        add3("chu-y", type, "", "Ô «" + label + "» trống ở mọi mục. Nếu anh đã điền mà vẫn thấy dòng này: key của trường này trong định nghĩa phải là «" + key + "».");
        return true;
      }
      return false;
    }
    function range(type, item, label, r, quiet) {
      if (r[0] == null || r[1] == null) { if (!quiet) add3("chu-y", type, item, label + ": còn ô trống (đang tính là 0 ngày)."); }
      else if (r[0] > r[1]) add3("loi", type, item, label + ": số nhỏ nhất (" + r[0] + ") lớn hơn số lớn nhất (" + r[1] + ").");
    }
    /* routes */
    var T = "Tuyến giao";
    if (!D.routes.length) add3("chu-y", T, "", "Chưa có tuyến nào, nên trang đang hiện NGÀY CŨ. Nhập 7 tuyến (bước 4 trong HUONG-DAN) để bật ngày mới.");
    keyCheck(T, D.routes, "Name", "name", function (x) { return x.name; });
    var qMake = keyCheck(T, D.routes, "Make min", "make_min", function (x) { return x.make[0]; }) | keyCheck(T, D.routes, "Make max", "make_max", function (x) { return x.make[1]; });
    var qShip = keyCheck(T, D.routes, "Ship min", "ship_min", function (x) { return x.ship[0]; }) | keyCheck(T, D.routes, "Ship max", "ship_max", function (x) { return x.ship[1]; });
    var seen = {};
    D.routes.forEach(function (r, i) {
      var n = nm(r, i);
      if (!ORIGINS.some(function (o) { return same(o, r.from); })) add3("loi", T, n, "Origin phải là Asia, US, UK, EU hoặc AU (đang là «" + (r.from || "trống") + "»).");
      if (!okRegion(r.region)) add3("loi", T, n, "Region phải là US, CA, AU, UK, EU hoặc ROW (đang là «" + (r.region || "trống") + "»).");
      range(T, n, "Ngày làm hàng (Make)", r.make, qMake); range(T, n, "Ngày vận chuyển (Ship)", r.ship, qShip);
      var k = String(r.from).toUpperCase() + ">" + String(r.region).toUpperCase();
      if (seen[k]) add3("loi", T, n, "Trùng với «" + seen[k] + "» (cùng Origin và Region). Chỉ mục nhập trước được dùng; xóa bớt 1 mục.");
      else seen[k] = n;
    });
    if (D.routes.length) {
      REGIONS.forEach(function (rg) {
        if (!seen["ASIA>" + rg] && rg !== "ROW") add3("goi-y", T, "", "Chưa có tuyến Asia → " + rg + ": khách " + rg + " đang dùng tuyến Asia → ROW.");
      });
      if (!seen["ASIA>ROW"]) add3("chu-y", T, "", "Chưa có tuyến Asia → ROW (dùng cho mọi nước không có tuyến riêng).");
      /* every "X from" the owner picked needs its route */
      LINES.forEach(function (l, i) {
        REGIONS.forEach(function (rg) {
          var o = fromOf(l, rg);
          if (o !== "Asia" && !seen[o.toUpperCase() + ">" + rg]) add3("loi", T, "", "Dòng «" + nm(l, i) + "»: khách " + rg + " nhận từ " + o + " nhưng chưa có tuyến " + o + " → " + rg + ". Thêm 1 mục Tuyến giao: Origin " + o + ", Region " + rg + " (đang tạm tính theo Châu Á).");
        });
      });
    }
    /* product lines */
    T = "Dòng sản phẩm";
    keyCheck(T, LINES, "Name", "name", function (x) { return x.name; });
    keyCheck(T, LINES, "Keywords", "keywords", function (x) { return x.keywords; });
    var kwSeen = {};
    LINES.forEach(function (l, i) {
      var n = nm(l, i);
      if (!(l.keywords || []).length && !isDefault(l)) add3("chu-y", T, n, "Chưa có từ khóa nào, nên dòng này không khớp sản phẩm nào.");
      (l.keywords || []).forEach(function (k) {
        var nk = norm(k);
        if (usaBase(nk)) { add3("goi-y", T, n, "Từ khóa «" + k + "» không cần nữa: tên base có “Print in USA” đã tự gửi từ Mỹ cho khách Mỹ. Xóa từ khóa này; dòng không còn từ khóa nào thì xóa cả dòng."); return; }
        if (nk.length <= 2) { add3("chu-y", T, n, "Từ khóa «" + k + "» bị bỏ qua (cần ít nhất 1 chữ cái hoặc số)."); return; }
        if (kwSeen[nk] && kwSeen[nk] !== n) add3("loi", T, n, "Từ khóa «" + k + "» trùng với dòng «" + kwSeen[nk] + "». Sản phẩm sẽ theo dòng nhập trước; xóa từ khóa ở 1 dòng.");
        else kwSeen[nk] = n;
      });
      [["US", l.us_from]].concat(REGIONS.map(function (rg) { return [rg, l.from && l.from[rg]]; })).forEach(function (p) {
        if (p[1] != null && String(p[1]).trim() && !allowed(p[0], canon(String(p[1]).trim()))) add3("loi", T, n, "Khách " + p[0] + " chỉ nhận từ " + ALLOWED[p[0]].join(" / ") + " (ô " + p[0] + " from đang là «" + p[1] + "», bị bỏ qua).");
      });
      if (l.make[0] != null || l.make[1] != null) range(T, n, "Ngày làm riêng (Make)", l.make);
    });
    /* printers (EZ Supplier) */
    T = "Nhà in";
    var tibSeen = {};
    D.suppliers.forEach(function (sp, i) {
      var n = nm(sp, i);
      if (sp.tib == null || String(sp.tib).trim() === "") { if (!(sp.keywords || []).length && !sp.name) add3("loi", T, n, "Cần Teeinblue ID (nhà in có sẵn trong Teeinblue) hoặc Name / Keywords (nhà in tạo tay)."); }
      else if (tibSeen[sp.tib]) add3("loi", T, n, "Teeinblue ID " + sp.tib + " trùng với «" + tibSeen[sp.tib] + "».");
      else tibSeen[sp.tib] = n;
      REGIONS.forEach(function (rg) {
        var v = sp.from && sp.from[rg];
        if (v != null && String(v).trim() && !allowed(rg, canon(String(v).trim()))) add3("loi", T, n, "Khách " + rg + " chỉ nhận từ " + ALLOWED[rg].join(" / ") + " (ô " + rg + " from đang là «" + v + "», bị bỏ qua).");
        var o = pick(v);
        if (o && allowed(rg, o) && D.routes.length && !D.routes.some(function (r) { return same(r.from, o) && same(r.region, rg); })) add3("loi", T, n, "Khách " + rg + " nhận từ " + o + " nhưng chưa có tuyến " + o + " → " + rg + " (đang tạm tính theo Châu Á).");
      });
      if (sp.make && (sp.make[0] != null || sp.make[1] != null)) range(T, n, "Ngày làm riêng (Make)", sp.make);
    });
    /* product bases (EZ Product base) */
    T = "Base riêng";
    var tidSeen = {};
    D.bases.forEach(function (b, i) {
      var n = nm(b, i);
      if (b.tid == null || String(b.tid).trim() === "") add3("loi", T, n, "Chưa có Teeinblue ID của base (bảng này hiện số đó khi mở một sản phẩm dùng base).");
      else if (tidSeen[b.tid]) add3("loi", T, n, "Teeinblue ID " + b.tid + " trùng với «" + tidSeen[b.tid] + "».");
      else tidSeen[b.tid] = n;
      ["US", "CA", "UK", "EU", "AU"].forEach(function (rg) {
        var v = b.from && b.from[rg];
        if (v != null && String(v).trim() && !allowed(rg, canon(String(v).trim()))) add3("loi", T, n, "Khách " + rg + " chỉ nhận từ " + ALLOWED[rg].join(" / ") + " (ô " + rg + " from đang là «" + v + "», bị bỏ qua).");
        var o = pick(v);
        if (o && allowed(rg, o) && D.routes.length && !D.routes.some(function (r) { return same(r.from, o) && same(r.region, rg); })) add3("loi", T, n, "Khách " + rg + " nhận từ " + o + " nhưng chưa có tuyến " + o + " → " + rg + " (đang tạm tính theo Châu Á).");
      });
      if (b.make && (b.make[0] != null || b.make[1] != null)) range(T, n, "Ngày làm riêng (Make)", b.make);
      if (b.ship_extra && b.ship_extra[0] != null && b.ship_extra[1] != null && b.ship_extra[0] > b.ship_extra[1]) add3("loi", T, n, "Ship extra: số nhỏ nhất lớn hơn số lớn nhất.");
    });
    if (D.bases.length >= 50) add3("chu-y", T, "", "Đã có 50 base riêng: Shopify chỉ cho trang đọc 50 mục đầu. Xóa bớt base không còn cần cài đặt riêng.");
    SPLIT_FIXED.forEach(function (p) { add3("goi-y", "Từ khóa", p[0], "Ô từ khóa «" + p[1] + "» chứa nhiều từ khóa; web đã tự tách. Nên tách thành nhiều ô cho rõ."); });
    var pg = window.ezDelivery && window.ezDelivery.line, pe = window.ezDelivery && window.ezDelivery.estimate;
    if (pe && pe.origin !== "Asia" && !same(pe.route.from, pe.origin)) add3("loi", "Tuyến giao", "", "Sản phẩm này: khách " + window.ezDelivery.region + " nhận từ " + pe.origin + " nhưng chưa có tuyến " + pe.origin + " → " + window.ezDelivery.region + ". Thêm 1 mục Tuyến giao (đang tạm tính theo Châu Á).");
    if (pg && pg.base && !pg.supplier) {
      if (pg.base.f == null || String(pg.base.f) === "") add3("chu-y", T, "", "Base tạo tay «" + (pg.base.label || pg.base.title) + "» chưa nhận ra nhà in, nên đang tính theo dòng sản phẩm / Châu Á. Ghi tên nhà in vào cuối label của base trong Teeinblue (ví dụ «… - Falconprint»), và khai nhà in đó trong EZ Supplier (Name hoặc Keywords).");
      else add3("chu-y", T, "", "Sản phẩm này dùng nhà in mã #" + pg.base.f + " (base «" + pg.base.title + "») chưa có trong EZ Supplier, nên đang tính theo dòng sản phẩm / Châu Á. Thêm 1 mục EZ Supplier với Teeinblue ID = " + pg.base.f + ".");
    }
    /* occasions */
    T = "Dịp lễ";
    keyCheck(T, D.occasions, "Date", "date", function (x) { return x.date; });
    D.occasions.forEach(function (o, i) {
      var n = nm(o, i), d = ymd(o.date), f = ymd(o.notice_from);
      if (d === null) { add3("loi", T, n, "Chưa có Date (ngày của dịp)."); return; }
      if (today > d) add3("goi-y", T, n, "Đã qua (" + md(d) + "). Có thể xóa mục này và các Cutoff của nó.");
      else if (!o.notice) add3("goi-y", T, n, "Show notice đang TẮT: khách không thấy thông báo của dịp này.");
      if (f !== null && f > d) add3("loi", T, n, "Notice from (" + md(f) + ") nằm sau ngày của dịp (" + md(d) + "), nên thông báo không bao giờ hiện.");
      (o.regions || []).forEach(function (r) { if (!okRegion(r)) add3("loi", T, n, "Vùng «" + r + "» không hợp lệ."); });
    });
    /* extra days */
    T = "Cộng thêm ngày";
    D.extras.forEach(function (x, i) {
      var n = nm(x, i), f = ymd(x.from), t = ymd(x.to);
      if (!x.days) add3("chu-y", T, n, "Extra days trống hoặc bằng 0, nên không cộng gì.");
      if (f === null && t === null) add3("loi", T, n, "Chưa có Date from / Date to, nên không áp dụng.");
      else if (f !== null && t !== null && f > t) add3("loi", T, n, "Date from (" + md(f) + ") nằm sau Date to (" + md(t) + ").");
      if (t !== null && today > t) add3("goi-y", T, n, "Đã hết hạn (" + md(t) + "). Có thể xóa.");
      if (x.origin && !/^all$/i.test(x.origin) && !canon(x.origin)) add3("loi", T, n, "Origin phải là All, Asia, US, UK, EU hoặc AU.");
    });
    /* cutoffs */
    T = "Cutoff";
    D.cutoffs.forEach(function (c, i) {
      var n = nm(c, i), occ = null;
      D.occasions.forEach(function (o) { if (o.id === c.occasion) occ = o; });
      if (!c.occasion) { add3("loi", T, n, "Chưa chọn Occasion (dịp)."); return; }
      if (c.origin && String(c.origin).trim() && !canon(c.origin)) add3("loi", T, n, "Origin phải là Asia, US, UK, EU, AU hoặc để trống.");
      if (!occ) { add3("loi", T, n, "Dịp đã chọn không còn (có thể đã bị xóa)."); return; }
      var ds = REGIONS.filter(function (r) { return c.dates[r]; });
      if (!ds.length) add3("chu-y", T, n, "Chưa điền ngày cho vùng nào.");
      var od = ymd(occ.date);
      ds.forEach(function (r) { if (od !== null && ymd(c.dates[r]) > od) add3("loi", T, n, "Ngày " + r + " (" + md(ymd(c.dates[r])) + ") nằm sau ngày của dịp."); });
      if (od !== null && today > od) add3("goi-y", T, n, "Dịp đã qua. Có thể xóa.");
    });
    return P;
  }
  function check() {
    var today = todayUTC(), box = document.getElementById("ezdl-check");
    if (!box) { box = document.createElement("div"); box.id = "ezdl-check"; document.body.appendChild(box); }
    var P = problems(today), cur = window.ezDelivery;
    var cnt = { loi: 0, "chu-y": 0, "goi-y": 0 };
    P.forEach(function (p) { cnt[p.level]++; });
    var h = '<button type="button" class="ezdl-x" aria-label="Đóng">×</button>' +
      "<h3>Kiểm tra ngày giao · hôm nay " + md(today) + (qs.get("ez_today") ? " (giả lập)" : "") + "</h3>" +
      "<p class='ezdl-sum'>Đã đọc: " + D.routes.length + " tuyến · " + LINES.length + " dòng sản phẩm · " + D.occasions.length + " dịp · " +
      D.extras.length + " cộng thêm ngày · " + D.cutoffs.length + " cutoff · " + D.suppliers.length + " nhà in · " + D.bases.length + " base riêng. " +
      (cnt.loi + cnt["chu-y"] ? "<b class='e'>" + cnt.loi + " lỗi</b>, <b class='w'>" + cnt["chu-y"] + " chú ý</b>" : "<b class='ok'>✓ Không thấy lỗi</b>") +
      (cnt["goi-y"] ? ", " + cnt["goi-y"] + " gợi ý" : "") + ". <small>(Sửa trong admin xong, chờ 1–2 phút rồi tải lại trang.)</small></p>";
    if (P.length) {
      h += "<ul class='ezdl-p'>";
      P.forEach(function (p) {
        h += "<li class='" + p.level + "'><b>" + { loi: "Lỗi", "chu-y": "Chú ý", "goi-y": "Gợi ý" }[p.level] + "</b> · " + esc(p.type) + (p.item ? " «" + esc(p.item) + "»" : "") + ": " + esc(p.text) + "</li>";
      });
      h += "</ul>";
    }
    if (LIVE && cur) {
      var e0 = cur.estimate;
      var b0 = cur.line.base, s0 = cur.line.supplier;
      var manual = b0 && (b0.f == null || String(b0.f) === "");
      h += "<p>Trang này: nhà in <b>" + (s0 ? esc(s0.name || s0.id) + "</b> (" + (manual ? "base tạo tay, nhận qua label" : "#" + esc(s0.tib)) + ")" : b0 ? (manual ? "?</b> <b class='w'>(base tạo tay, chưa nhận ra)</b>" : "#" + esc(b0.f) + "</b> <b class='w'>(chưa khai)</b>") : "?</b> <small>(" + esc(TEE_STATE) + ")</small>") +
        (b0 ? " · base <i>" + esc(b0.title) + "</i> <small>(Teeinblue base ID <b>" + esc(b0.id) + "</b>" + (cur.line.pbase ? ", <b>có cài đặt riêng: " + esc(cur.line.pbase.name || cur.line.pbase.id) + "</b>" : "") + ")</small>" + (b0.label && b0.label !== b0.title ? " <small>(label: " + esc(b0.label) + ")</small>" : "") : "") + " · dòng <b>" + esc(cur.line.name || cur.line.id) + "</b>" + (cur.line.usaBase ? " <small>(tên base có “Print in …”: " + Object.keys(cur.line.usaBase).map(function (k) { return "khách " + k + " nhận từ " + (ORIGIN_VN[k] || k); }).join(", ") + ")</small>" : "") + " · khách " + cur.region + " · gửi từ " + (ORIGIN_VN[e0.origin] || e0.origin) + (e0.origin !== "Asia" && !same(e0.route.from, e0.origin) ? " <b class='e'>(chưa có tuyến, tạm tính Châu Á)</b>" : "") +
        " · làm " + num(e0.make[0]) + "–" + num(e0.make[1]) + " + ship " + num(e0.route.ship[0]) + "–" + num(e0.route.ship[1]) + (e0.shipAdd && (e0.shipAdd[0] || e0.shipAdd[1]) ? " (+" + e0.shipAdd[0] + "–" + e0.shipAdd[1] + " riêng của base)" : "") +
        (e0.extra ? " + " + e0.extra + " (" + esc(e0.extraBy.name) + ")" : "") + " ngày → <b>" + rangeA(e0.arrive[0], e0.arrive[1]) + "</b>" +
        (cur.notice ? " · “" + esc(cur.notice.text) + "”" : "") + "</p>" +
        "<div class='ezdl-tw'><table><tr><th>Dòng sản phẩm</th>" + REGIONS.map(function (r) { return "<th>" + r + "</th>"; }).join("") + "</tr>";
      var rows = LINES.slice();
      if (!LINES.some(isDefault)) rows.push(OTHER);
      D.suppliers.forEach(function (sp) { var c = {}; for (var k in OTHER) c[k] = OTHER[k]; c.name = "Nhà in " + (sp.name || sp.id) + " (sản phẩm không thuộc dòng nào)"; c.supplier = sp; rows.push(c); });
      rows.forEach(function (l) {
        h += "<tr><td>" + esc(l.name || l.id) + localNote(l) + "</td>";
        REGIONS.forEach(function (r) {
          var e = estimate(l, r, today), n = notice(l, r, e);
          h += "<td>" + rangeA(e.arrive[0], e.arrive[1]) + (e.fixed ? " <small>cố định " + e.fixed[0] + "–" + e.fixed[1] + "</small>" : "") + (e.extra ? " <small>+" + e.extra + "</small>" : "") + (n ? "<br><small class='" + (n.before ? "b" : "a") + "'>" + (n.before ? "đặt trước " + md(n.cutoff) : "đã qua cutoff") + "</small>" : "") + "</td>";
        });
        h += "</tr>";
      });
      h += "</table></div>";
    }
    h += "<p><small>Xem ngày khác: thêm <code>&ez_today=2026-12-05</code> · nước khác: <code>&ez_country=AU</code>. Khách không thấy bảng này.</small></p>";
    box.innerHTML = h;
    box.querySelector(".ezdl-x").onclick = function () { box.remove(); };
  }
  /* "(US, CA nhận từ Mỹ · UK nhận từ Anh)" */
  function localNote(l) {
    var by = {};
    REGIONS.forEach(function (rg) { var o = fromOf(l, rg); if (o !== "Asia") (by[o] = by[o] || []).push(rg); });
    var parts = Object.keys(by).map(function (o) { return by[o].join(", ") + " nhận từ " + (ORIGIN_VN[o] || o); });
    return parts.length ? " <small>(" + parts.join(" · ") + ")</small>" : "";
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- styles (one line of words; the check table only for the owner) ---------- */
  var css = document.createElement("style");
  css.textContent =
    ".ezdl-note{margin:6px 0 0;font-size:13px;line-height:18px;font-weight:500}" +
    ".ezdl-note--before{color:var(--ezp-teal-ink,#0b7f89)}.ezdl-note--after{color:#b54708}" +
    ".new-shipping .box-shipping-content:has(>.ezdl-note){flex-wrap:wrap}.new-shipping .ezdl-note--line{flex:0 0 100%;order:99;margin:2px 0 0}" +
    ".ezp-steps-wrap>.ezdl-note--steps{text-align:center;margin:-7px 0 10px}" +
    "#ezdl-check{position:fixed;z-index:2147483000;left:12px;right:12px;bottom:12px;max-height:70vh;overflow:auto;background:#fff;border:1px solid #e5e5e5;border-radius:12px;box-shadow:0 12px 40px rgba(0,0,0,.18);padding:14px 16px;font:13px/1.45 system-ui,sans-serif;color:#1d1d1f}" +
    "#ezdl-check h3{margin:0 0 6px;font-size:15px}#ezdl-check table{border-collapse:collapse;width:100%;margin-top:8px}" +
    "#ezdl-check th,#ezdl-check td{border:1px solid #eee;padding:5px 7px;text-align:left;vertical-align:top}#ezdl-check th{background:#fafafa}" +
    "#ezdl-check small.b{color:#0b7f89}#ezdl-check small.a{color:#b54708}" +
    "#ezdl-check .ezdl-tw{overflow-x:auto;-webkit-overflow-scrolling:touch}#ezdl-check td{white-space:nowrap}#ezdl-check td:first-child{white-space:normal;min-width:120px}" +
    "#ezdl-check .ezdl-p{margin:8px 0;padding:0;list-style:none}#ezdl-check .ezdl-p li{padding:5px 8px;border-radius:6px;margin:3px 0;background:#f5f5f5}" +
    "#ezdl-check .ezdl-p li.loi{background:#fdecea}#ezdl-check .ezdl-p li.chu-y{background:#fff4e5}#ezdl-check b.e{color:#b42318}#ezdl-check b.w{color:#b54708}#ezdl-check b.ok{color:#067647}" +
    ".ezdl-x{position:absolute;top:8px;right:10px;border:0;background:none;font-size:22px;cursor:pointer}";
  document.head.appendChild(css);

  /* ---------- when to (re)apply: now, when Teeinblue/the theme add the blocks, when the variant changes ---------- */
  if (!LIVE) {   /* nothing on the page changes until a route exists; the owner can still check what he entered */
    if (qs.get("ez_delivery_check")) { if (document.body) check(); else document.addEventListener("DOMContentLoaded", check); }
    return;
  }
  onTee = function () { soon(); if (qs.get("ez_delivery_check")) setTimeout(check, 120); };
  var t = 0;
  function soon() { clearTimeout(t); t = setTimeout(apply, 60); }
  apply();
  loadTee();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  ["change", "click"].forEach(function (ev) { document.addEventListener(ev, soon, true); });
  ["pushState", "replaceState"].forEach(function (k) {
    var orig = history[k];
    if (typeof orig !== "function") return;
    history[k] = function () { var r = orig.apply(this, arguments); soon(); return r; };
  });
  window.addEventListener("popstate", soon);
  window.addEventListener("ez:variant-url", soon);   /* Ban-67: a variant-only address change skips the wrappers above (ez-personalize.js §59) */
})();
